module.exports = __webpack_public_path__ + "img/portada.e1fcce54.png";